import { ChangeEvent, FC } from "react";
import InputIcon from "../../../components/atoms/InputIcon";
import styles from "./styles.scss";

interface FileInputIconProps {
  karteFileAttachments?: File[];
  setKarteFileAttachments: (value: File[]) => void;
}

export const FileInputIcon: FC<FileInputIconProps> = ({
  karteFileAttachments,
  setKarteFileAttachments,
}) => {
  return (
    <InputIcon
      iconName="icon-file"
      inputAttributes={{
        id: "karte_attachments_attributes",
        type: "file",
      }}
      className={styles.footer__icon}
      tooltipLabel="ファイルの追加( PDF,Word,Excel,PPT )"
      onChange={handleAddFileAttachment(
        karteFileAttachments,
        setKarteFileAttachments,
      )}
    />
  );
};

const handleAddFileAttachment =
  (
    karteFileAttachments: File[] | undefined,
    setKarteFileAttachments: (value: File[]) => void,
  ) =>
  (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.currentTarget.files?.[0];
    if (!file) {
      return;
    }
    setKarteFileAttachments([...(karteFileAttachments ?? []), file]);
  };
